import { filterFeaturesByPriority } from "./brandedFares.js";
export const SEAT_FEATURES_INCLUDED_PRIORITY = [
    { featureName: "PRIVACY_SEAT", availability: "INCLUDED" },
    { featureName: "LIE_FLAT_SEAT", availability: "INCLUDED" },
    { featureName: "EXTRA_LEGROOM_SEAT", availability: "INCLUDED" },
    { featureName: "PREMIUM_SEAT", availability: "INCLUDED" },
    { featureName: "BASIC_SEAT", availability: "INCLUDED" },
    { featureName: "PRE_RESERVED_SEAT_ASSIGNMENT", availability: "INCLUDED" }
];
const SEAT_FEATURES_SELLABLE_PRIORITY = SEAT_FEATURES_INCLUDED_PRIORITY.map((feature) => ({
    ...feature,
    availability: "SELLABLE"
}));
const SEAT_FEATURES_EXCLUDED_PRIORITY = SEAT_FEATURES_INCLUDED_PRIORITY.map((feature) => ({
    ...feature,
    availability: "NOT_INCLUDED"
})).reverse();
const SEAT_PRIORITY = [
    ...SEAT_FEATURES_INCLUDED_PRIORITY,
    ...SEAT_FEATURES_SELLABLE_PRIORITY,
    ...SEAT_FEATURES_EXCLUDED_PRIORITY
];
export const clarifySeatFeatures = (features) => filterFeaturesByPriority(features, SEAT_PRIORITY);
export const clarifyDeltaSeatFeatures = clarifySeatFeatures;
